// this functin will be used to bind user account with his nickname
import { jwtDecode } from 'jwt-decode';
import { signMessage } from '@wagmi/core';

import { config } from '../index';
import { API } from '../constants/api';
import { USER_SIGNED_JWT_MAP } from '../constants/localStorage';

import { getHeader } from './api';
import {
  updateLocalStorageItemInMap,
  getMapFromLoacalStorage,
} from './updateLocalStorageItem';
import { Emitter } from '../hooks/useModalContext';
import { store } from '../store';

export const getJWT = (address?: `0x${string}`) => {
  if (address) {
    const jwt = getMapFromLoacalStorage(USER_SIGNED_JWT_MAP);
    const addrJwt = jwt && jwt[address];
    return addrJwt;
  }
  return '';
};

export const onAuthenticate = async (curWalletAddr: `0x${string}`) => {
  try {
    // 获取playAddress
    const playAddress = store.getState().common.playAddress;
    console.log('playAddress, curWalletAddr', playAddress, curWalletAddr);
    if (playAddress) {
      curWalletAddr = playAddress as `0x${string}`;
    }

    const jwt = getJWT(curWalletAddr);

    let jwtExpire = 0,
      jwtWalletAddr = '';
    // check jwt valid
    if (jwt) {
      //   @ts-ignore
      const { expire = 0, address } = jwtDecode(jwt);
      jwtExpire = expire;
      jwtWalletAddr = address;
      console.log('jwtWalletAddr', jwtWalletAddr);
    }
    const currentTime = Math.trunc(new Date().getTime() / 1000);

    if (!jwt || jwtExpire < currentTime) {
      console.log('jwtExpire', jwtExpire, currentTime);
      // @ts-ignore 是否展示弹窗
      const result = await window.sigeMessage.show();
      // go on when click sign message button
      if (result) {
        const newJwt = await getSignedJwt(curWalletAddr);
        // store new jwt in the local storage
        updateLocalStorageItemInMap(USER_SIGNED_JWT_MAP, curWalletAddr, newJwt);
      }
    }
    // @ts-ignore
    await window.sigeMessage.hide();
  } catch (e) {
    throw e;
  }
};

export const getSignedJwt = async (curWalletAddr: string) => {
  try {
    const res = await fetch(
      `${API.AUTH}/basic_jwt?address=${curWalletAddr}`
    ).then(res => res.json());

    const basicJwt = res.result;
    if (!basicJwt) {
      throw new Error('cannot fetch basic jwt');
    }
    // @ts-ignore
    const { message } = jwtDecode(basicJwt);
    if (!message) {
      throw new Error("message don't exist in the basic jwt");
    }
    //  @ts-ignore
    const result = await signMessage(config, {
      account: curWalletAddr as `0x${string}`,
      message,
    });

    const finalRes = await fetch(
      `${API.AUTH}/signed_jwt?signedMessage=${result}`,
      {
        headers: getHeader(basicJwt),
      }
    );
    const { result: finalResult } = await finalRes.json();
    if (finalRes.status !== 200) throw new Error(finalResult);

    return finalResult;
  } catch (e) {
    throw e;
  }
};
